import script from "./ViewFamilySelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./ViewFamilySelector.vue?vue&type=script&lang=ts&setup=true"

import "./ViewFamilySelector.vue?vue&type=style&index=0&id=7b144bbf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b144bbf"]])

export default __exports__